import { useState, useRef } from 'react';

export default function ContactSection() {
  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formMessage, setFormMessage] = useState('');
  const formRef = useRef<HTMLFormElement>(null);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    const honeypotEl = form.querySelector<HTMLInputElement>('input[name="website_alt"]');
    if (honeypotEl && honeypotEl.value.trim() !== '') {
      setFormStatus('success');
      setFormMessage('Mensagem enviada com sucesso! Entraremos em contato em breve.');
      return;
    }

    setFormStatus('loading');
    setFormMessage('');

    const formData = new FormData(form);
    const name = (formData.get('name') as string || '').trim();
    const email = (formData.get('email') as string || '').trim();
    const phone = (formData.get('phone') as string || '').trim();
    const message = (formData.get('message') as string || '').trim();

    const whatsappText = [
      'Olá! Gostaria de agendar uma consulta.',
      '',
      `*Nome:* ${name}`,
      `*E-mail:* ${email}`,
      `*WhatsApp:* ${phone}`,
    ];

    if (message) {
      whatsappText.push(`*Mensagem:* ${message}`);
    }

    const whatsappUrl = `https://api.whatsapp.com/send/?phone=5585999372109&text=${encodeURIComponent(whatsappText.join('\n'))}&type=phone_number&app_absent=0&utm_source=site`;

    // Envia em background pro formulário Readdy (registro), mas não bloqueia o WhatsApp
    try {
      fetch('https://readdy.ai/api/form/d9i00cec26n1c7c5poq0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as unknown as URLSearchParams).toString(),
      }).catch(() => {});
    } catch {
      // Silencioso — o canal principal é o WhatsApp
    }

    setFormStatus('success');
    setFormMessage('Abrindo WhatsApp...');
    window.open(whatsappUrl, '_blank');
    form.reset();
  };

  return (
    <section
      id="contato"
      className="relative py-20 md:py-28 overflow-hidden"
      style={{ backgroundColor: '#F8F7F5' }}
    >
      <div className="max-w-[800px] mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <p
            className="text-sm tracking-[0.15em] mb-4"
            style={{
              fontFamily: 'var(--font-body)',
              color: '#C8A96A',
              fontWeight: 500,
            }}
          >
            CONTATO
          </p>
          <h2
            className="text-3xl md:text-5xl mb-5"
            style={{
              fontFamily: 'var(--font-heading)',
              color: '#2E2E2E',
              fontWeight: 500,
              lineHeight: 1.2,
            }}
          >
            Agende sua consulta
          </h2>
          <p
            className="text-sm md:text-base"
            style={{
              fontFamily: 'var(--font-body)',
              color: '#6B6560',
              fontWeight: 300,
            }}
          >
            Preencha o formulário abaixo e nossa equipe entrará em contato para agendar sua avaliação.
          </p>
        </div>

        <form
          ref={formRef}
          onSubmit={handleSubmit}
          className="rounded-[24px] p-6 md:p-10 max-w-[560px] mx-auto"
          style={{
            backgroundColor: '#FFFFFF',
            border: '1px solid rgba(0, 0, 0, 0.04)',
            boxShadow: '0 4px 24px rgba(0, 0, 0, 0.04)',
          }}
        >
          <div className="flex flex-col gap-5">
            <div>
              <label
                className="block text-xs tracking-[0.06em] mb-2"
                style={{
                  fontFamily: 'var(--font-body)',
                  color: '#4A4540',
                  fontWeight: 500,
                }}
              >
                Nome completo
              </label>
              <input
                type="text"
                name="name"
                required
                placeholder="Seu nome"
                className="w-full px-4 py-3 rounded-[12px] text-sm outline-none transition-all duration-300 focus:ring-1"
                style={{
                  fontFamily: 'var(--font-body)',
                  border: '1px solid #EAE4DD',
                  backgroundColor: '#F8F7F5',
                  color: '#2E2E2E',
                }}
              />
            </div>

            <div>
              <label
                className="block text-xs tracking-[0.06em] mb-2"
                style={{
                  fontFamily: 'var(--font-body)',
                  color: '#4A4540',
                  fontWeight: 500,
                }}
              >
                E-mail
              </label>
              <input
                type="email"
                name="email"
                required
                placeholder="seu@email.com"
                className="w-full px-4 py-3 rounded-[12px] text-sm outline-none transition-all duration-300 focus:ring-1"
                style={{
                  fontFamily: 'var(--font-body)',
                  border: '1px solid #EAE4DD',
                  backgroundColor: '#F8F7F5',
                  color: '#2E2E2E',
                }}
              />
            </div>

            <div>
              <label
                className="block text-xs tracking-[0.06em] mb-2"
                style={{
                  fontFamily: 'var(--font-body)',
                  color: '#4A4540',
                  fontWeight: 500,
                }}
              >
                WhatsApp
              </label>
              <input
                type="tel"
                name="phone"
                required
                placeholder="(85) 99999-9999"
                className="w-full px-4 py-3 rounded-[12px] text-sm outline-none transition-all duration-300 focus:ring-1"
                style={{
                  fontFamily: 'var(--font-body)',
                  border: '1px solid #EAE4DD',
                  backgroundColor: '#F8F7F5',
                  color: '#2E2E2E',
                }}
              />
            </div>

            <div>
              <label
                className="block text-xs tracking-[0.06em] mb-2"
                style={{
                  fontFamily: 'var(--font-body)',
                  color: '#4A4540',
                  fontWeight: 500,
                }}
              >
                Mensagem (opcional)
              </label>
              <textarea
                name="message"
                rows={3}
                maxLength={500}
                placeholder="Conte um pouco sobre o que você está buscando..."
                className="w-full px-4 py-3 rounded-[12px] text-sm outline-none transition-all duration-300 focus:ring-1 resize-none"
                style={{
                  fontFamily: 'var(--font-body)',
                  border: '1px solid #EAE4DD',
                  backgroundColor: '#F8F7F5',
                  color: '#2E2E2E',
                }}
              />
            </div>

            <div className="honeypot-field">
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
            </div>

            <button
              type="submit"
              disabled={formStatus === 'loading'}
              className="w-full py-3.5 rounded-full text-sm font-semibold tracking-[0.03em] whitespace-nowrap cursor-pointer transition-all duration-300 disabled:opacity-60 mt-2"
              style={{
                backgroundColor: '#42554A',
                color: '#FFFFFF',
                fontFamily: 'var(--font-body)',
              }}
            >
              {formStatus === 'loading' ? 'Enviando...' : 'Agendar consulta'}
            </button>

            {formStatus === 'success' && formMessage && (
              <p
                className="text-center text-sm"
                style={{ fontFamily: 'var(--font-body)', color: '#42554A', fontWeight: 500 }}
              >
                {formMessage}
              </p>
            )}
            {formStatus === 'error' && formMessage && (
              <p
                className="text-center text-sm"
                style={{ fontFamily: 'var(--font-body)', color: '#C0392B', fontWeight: 400 }}
              >
                {formMessage}
              </p>
            )}
          </div>
        </form>
      </div>
    </section>
  );
}